module.exports = __webpack_public_path__ + "img/KC_BG4.63d82a9c.png";